import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import '../css/ManageMissions.css';
import API_BASE_URL from '../api';

const ManageMissions = () => {
  const [missions, setMissions] = useState([]);
  const [filteredMissions, setFilteredMissions] = useState([]);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [showFullDescription, setShowFullDescription] = useState({});
  const navigate = useNavigate();
  const userId = localStorage.getItem('userId');
  const arrive = localStorage.getItem('arrive'); // Get arrive value from localStorage

  useEffect(() => {
    if (arrive === 'Freelance') {
      // Redirect or show an error message if the user is a freelancer
      navigate('/dashboard'); // or navigate to another page
    } else {
      const fetchMissions = async () => {
        const token = localStorage.getItem('authToken');
        try {
          const response = await axios.get(`${API_BASE_URL}/api/missions`, {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          });

          const allMissions = response.data;
          const userMissions = allMissions.filter(mission => mission.assignedUserId === userId);

          setMissions(allMissions);
          setFilteredMissions(userMissions);
        } catch (error) {
          setError('Erreur lors de la récupération des missions');
        }
      };

      fetchMissions();
    }
  }, [userId, arrive, navigate]);

 

  const truncateHtml = (html, maxLength) => {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    const text = tempDiv.innerText;
    return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
  };

  return (
    <div className="manage-missions-container">
      <Sidebar />
      <div className="main-content">
        <div className="header">
          <h2>Gérer les besoins</h2>
          <button className="submit-mission-button" onClick={() => navigate('/submit-mission')}>Publier un besoin</button>
        </div>
        <p>Total des besoins : {filteredMissions.length}</p>
        {error && <div className="alert alert-danger mt-3">{error}</div>}
        {success && <div className="alert alert-success mt-3">{success}</div>}
        <ul className="missions-list">
          {Array.isArray(filteredMissions) && filteredMissions.map((mission) => (
            <li key={mission._id} className="mission-item">
              <div className="mission-header">
                <div className="mission-ref">{mission.reference}</div>
                <div className={`mission-status ${mission.status === 'published' ? 'active' : 'inactive'}`}>
                  {mission.status === 'published' ? 'En ligne' : 'Hors ligne'}
                </div>
              </div>
              <div className="mission-details">
                <h3>{mission.name}</h3>
                <div
                  className="mission-description"
                  dangerouslySetInnerHTML={{ __html: showFullDescription[mission._id] ? mission.description : truncateHtml(mission.description, 300) }}
                />
                <div className="mission-keywords">
                  {Array.isArray(mission.skills) && mission.skills.map((keyword, index) => (
                    <span key={index} className="keyword">{keyword.trim()}</span>
                  ))}
                </div>
                <p className="publish-date">Publié le: {new Date(mission.createdAt).toLocaleDateString()}</p>
                {mission.assignedUserId === userId && (
                  <div className="button-container">
                    <Link to={`/missions/${mission._id}`} className="view-offer-button">Voir ce besoin</Link>
                  </div>
                )}
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ManageMissions;
